const getDropTargetElement = (rootState) => rootState.dnd.targetElement;

export default getDropTargetElement;
